import {IRange} from "@pg-design/inputs-module";

import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const price: ISearchFilterSlot<"price", IRange<string>> = {
    id: "price",
    label: "Budżet",
    rhfFilter: true,
    filters: [
        {
            id: "price",
            type: SearchFilterTypes.BUDGET,
            filterOptions: []
        }
    ]
};
import {IRange} from "@pg-design/inputs-module";

import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const price: ISearchFilterSlot<"price", IRange<string>> = {
    id: "price",
    label: "Budżet",
    rhfFilter: true,
    filters: [
        {
            id: "price",
            type: SearchFilterTypes.BUDGET,
            filterOptions: []
        }
    ]
};
